var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "map-marker_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#map-marker_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 35c4.042-3.417 7.052-6.594 9.031-9.531C31.011 22.53 32 19.812 32 17.312c0-3.791-1.208-6.791-3.625-9C25.958 6.104 23.167 5 20 5s-5.958 1.104-8.375 3.313C9.208 10.52 8 13.52 8 17.313c0 2.5.99 5.218 2.969 8.156C12.948 28.406 15.959 31.583 20 35Zm0-14.375c-.875 0-1.615-.302-2.219-.906-.604-.604-.906-1.344-.906-2.219 0-.875.302-1.615.906-2.219.604-.604 1.344-.906 2.219-.906.875 0 1.615.302 2.219.906.604.604.906 1.344.906 2.219 0 .875-.302 1.615-.906 2.219-.604.604-1.344.906-2.219.906Z"
}))));
export default SvgMapMarker;